import React from 'react';
import '../App.css';


function Footer() {
		
		return(
			<div></div>
		)
}

export default Footer;